/*
 * SPDX-FileCopyrightText: 2016-2021 CERN.
 * SPDX-FileCopyrightText: 2023 Northwestern University.
 * SPDX-FileCopyrightText: 2026-2026 TU Wien.
 * SPDX-License-Identifier: MIT
 */

import React from "react";
import ReactDOM from "react-dom";
import { i18next } from "@translations/invenio_communities/i18next";

import CommunitiesCardGroup from "@js/invenio_communities/community/CommunitiesCardGroup";

const themedCommunitiesContainer = document.getElementById("themed-communities");

if (themedCommunitiesContainer) {
  ReactDOM.render(
    <CommunitiesCardGroup
      fetchDataUrl="/api/communities?q=theme:*&sort=newest&page=1&size=5"
      emptyMessage={i18next.t("There are no themed communities yet.")}
      defaultLogo="/static/images/square-placeholder.png"
    />,
    themedCommunitiesContainer
  );
}
